import {RankingUserApiModel} from './ranking-user.api-model';
import {UserViewModel} from '../user/settings/user.view-model';

export class RankingUserViewModel {
  public user: UserViewModel;
  public averageRating: number;
  public ratingCount: number;
  public rankedVehicleCount: number;

  public constructor(apiModel: RankingUserApiModel = new RankingUserApiModel()) {
    this.user = new UserViewModel(apiModel.user);
    this.averageRating = apiModel.averageRating;
    this.ratingCount = apiModel.ratingCount;
    this.rankedVehicleCount = apiModel.rankedVehicleCount;
  }
}
